import reset from 'styled-reset';
import { createGlobalStyle } from 'styled-components';

export const GlobalStyles = createGlobalStyle`
  ${reset};

  * {
    box-sizing: border-box;
    word-break: keep-all;

    ::-webkit-scrollbar {
      width: 14px;
    }

    ::-webkit-scrollbar-thumb {
      background-color: #c9c9c9;
      border: 4px solid transparent;
      border-radius: 20px;
      background-clip: padding-box;
    }
  }

  body {
    font-size: 15px;
    line-height: 1.5;
    font-family: "Figtree", "Pretendard", sans-serif;
    background-color: ${(props) => props.theme.global.bgColor};
    color: ${(props) => props.theme.global.textColor};
    overflow-x: hidden;
  }

  a {
    color: inherit;
    text-decoration: none;
  }

  img {
    display: block;
  }

  button {
    border: none;
    padding: 0;
    background-color: transparent;
    margin: 0;
    color: inherit;
    font: inherit;
    cursor: pointer;

    &:disabled {
      cursor: default;
    }
  }

  .no-dragging {
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }

  .dragging {
    -webkit-user-select: auto;
    -moz-user-select: auto;
    -ms-user-select: auto;
    user-select: auto;
  }

  input, select, textarea {
    font-family: inherit;
  }

  table, th, td {
    border-collapse: collapse;
  }

  .react-tooltip {
    z-index: 9999999;
    white-space: pre-line;
  }
`;

export default GlobalStyles;
